import React, { useEffect, useState } from 'react'
import { LANGUAGES, LANGUAGES_AXIS } from '../../../utils/selectionLanguages';
import './VideoConsentLanguageSelection.css';
import { languageTutorialImg } from '../../../images/btnIcons';
import LanguageTranslater from '../../HOC/LanguageTranslater';
import { Button } from 'unified-ui-components-library'

const VideoConsentLanguageSelection = ({ handleLanguageSelection, translate }) => {
    const [selectedConsentLang, setSelectedConsentLang] = useState("english")
    const [showContinueBtn, setShowContinueBtn] = useState(true)
    const [chanelName, setChanelNamev] = useState(localStorage.getItem('channelName')?.toLocaleLowerCase())
    const [languages, setLanguages] = useState([])
    const [searchKey, setSearchKey] = useState('')
    const [allLanguages, setAllLanguages] = useState([])

    useEffect(() => {
        if (chanelName == 'x') {
            LANGUAGES.push(...LANGUAGES_AXIS)
        }
        setLanguages(LANGUAGES)
        setAllLanguages(LANGUAGES)

    }, [])

    const changeLanguage = (selectedConsentLang) => {
        const ln = selectedConsentLang;
        handleLanguageSelection(ln)
        setShowContinueBtn(false)
    };

    return (
        <>
            <div className="consent-languages-header">
                <img src={languageTutorialImg} alt='select_lang_icn' />
                <div className='consent-lang-heading-cntnr'>
                    <p className='consent-lang-heading-txt'>Please select your preferred</p>
                    <p className='consent-lang-heading-txt'>language for Video Consent</p>
                </div>
            </div>
            <div className="selectLanguageWrapper consent-languages-wrapper">
                <ul className="languageList">
                    {
                        languages.map(({ code, label }) => (
                            <li
                                key={code}
                                onClick={() => setSelectedConsentLang(code)}
                                className={selectedConsentLang == code ? "activeLang" : ""}
                            >
                                <p className='lang-name manipuri-font'>{label}</p>
                                {code !== 'english' && <span className='consent-lang-code' >{code}</span>}
                            </li>
                        ))
                    }
                </ul>
                <div className="btnNextWrapper">
                    <Button disabled={selectedConsentLang ? false : true} 
                    type="submit"
                    buttonType='primary'
                    width="264"
                    onClick={() => changeLanguage(selectedConsentLang)}
                    className='btnNext'>{translate("Next")}</Button>
                </div>
            </div>
        </>
    )

}

export default LanguageTranslater(VideoConsentLanguageSelection);